import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/basic-health/lab-procedures/serumGlucose";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	serumGlucose: {
		id: "form.serum_glucose",
		defaultMessage: "Vércukor"
	},
	value: {
		id: "form.serum_glucose.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "bh_serumGlucose",
	value: {
		schemaId: "serumGlucose",
		title: messages.serumGlucose,
		validator,
		fieldset,
		isImportant: true
	}
};
